import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ndpxldtsdnobyzukftzq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5kcHhsZHRzZG5vYnl6dWtmdHpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAyNzE2MTUsImV4cCI6MjA2NTg0NzYxNX0.fdC5XyYv9hJuu0XBD0hLNfh0uA7O_wYWaM_LMPEpeX0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);